import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTreeComponent } from 'ng-zorro-antd/tree';
import { NbApiService } from '@service/nb-api.service';

/**
 * 设备选择器
 */
@Component({
  selector: 'device-selector',
  templateUrl: './device-selector.component.html',
})
export class DeviceSelectorComponent implements OnInit {
  @ViewChild('tree') tree: NzTreeComponent;
  @Input() visible: boolean = false;
  @Input() id: any;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<boolean>();
  title = '选择设备';
  loading = false;
  defaultCheckedKeys: any[] = [];
  nodes: any[] = [];
  checkedIds: any[] = [];

  constructor(private nbApi: NbApiService, public http: _HttpClient, public msg: NzMessageService, public notify: NzNotificationService) {}

  ngOnInit(): void {
    this.getBoardDeviceList();
  }

  // 获取设备
  getBoardDeviceList() {
    this.nbApi.getBoardDeviceList().subscribe((e: any) => {
      if (e.code === 200) {
        const data = e.data || [];
        data.forEach((item: any, index: number) => {
          item.title = item.domainName;
          index === 0 ? (item.expanded = true) : (item.expanded = false);
          item.children = item.qsDevices || [];
          item.notSelected = true;
          item.key = 'parent';
          index === 0 ? (item.expanded = true) : (item.expanded = false);
          if (item.children.length > 0) {
            item.qsDevices.forEach((dev: any) => {
              item.key = `${item.key}-${dev.id}`;
              dev.title = `${dev.deviceName}（${dev.deviceIp}） `;
              dev.isLeaf = true;
              dev.key = dev.id;
            });
          }
        });
        this.nodes = data;
      }
    });
  }

  nzEvent(event: any): void {
    const data = event.node.origin;
    if (data.checked) {
      // 选择得父层级
      if (data.notSelected) {
        const idStrs = data.key.split('-');
        idStrs.shift();
        const ids = idStrs.map((str: string) => parseInt(str, 10));
        this.checkedIds = this.checkedIds.concat(ids);
        this.checkedIds = [...new Set(this.checkedIds)];
      } else {
        this.checkedIds.push(data.key);
      }
    } else {
      // 选择得父层级
      if (data.notSelected) {
        const idStrs = data.key.split('-');
        idStrs.shift();
        const ids = idStrs.map((str: string) => parseInt(str, 10));
        for (let i = this.checkedIds.length - 1; i >= 0; i--) {
          if (ids.includes(this.checkedIds[i])) {
            this.checkedIds.splice(i, 1);
          }
        }
      } else {
        this.checkedIds = this.checkedIds.filter((item) => item != data.key);
      }
    }
    console.log(this.checkedIds);
  }

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  submit(): void {
    if (this.id) {
      const par = { deviceList: this.checkedIds || [], playId: this.id };
      this.loading = true;
      this.nbApi.play(par).subscribe(
        (e: any) => {
          if (e.code === 200) {
            this.msg.success('请求成功');
            this.refresh.emit(true);
            this.loading = false;
            this.close();
          }
        },
        () => (this.loading = false),
      );
    }
  }
}
